/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Navigate } from 'react-router';

import { type NavigationRoute } from './navigationRoute';

/**
 * Retired paths that still receive traffic from old links and bookmarks. These
 * stay client-side (unlike {@link externalRedirectRoutes}, which bounces the
 * browser to ServiceNow), so `replace` keeps them out of the history stack.
 */
export const internalRedirectRoutes: NavigationRoute[] = [
    {
        path: '/new-inventory',
        element: <Navigate to="/new-implementations" replace />,
    },
    {
        path: '/rentals',
        element: <Navigate to="/" replace />,
    },
];
